import React, { Component, Fragment } from "react";
import { Link ,  NavLink , withRouter } from "react-router-dom";
import Login from "./Login";
import Reset from "./password/Reset";
import style from "../writer/writer.css";
import "../general/include/HomeNavBar.css"
import AppContext from "../../contexts/AppContext";
import {list as Appcats} from "../../services/appCategory";

export class Header extends Component {
    state = {       
        login: false,
		resetPassword: false
    };

    componentDidMount() {  
        if(this.props.prompt === 'login')
        {
            this.setState({ resetPassword: false, login: true });
        }
    };

    toggleLogin = () => {
        //console.log(this.context.state.isAuth()  ? '1' : '0');
        if(this.context.state.isAuth())
        {
            this.setState({ resetPassword: false, login: false });
            if (this.context.state.user.type === "employer") {
                window.location = "/employer/dashboard";
            }
            if (this.context.state.user.type === "admin") {
                window.location = "/admin/dashboard";
            }
            if (this.context.state.user.type === "writer") {
                window.location = "/account";
            }
            
        }
        else{
            this.setState({ resetPassword:false, login: this.state.login === true ? false : true });
        }
        
    };
	
	toggleResetPassword = () => {
        this.setState({ login:false, resetPassword: this.state.resetPassword === true ? false : true });
    };
	
	hideAll = () => {
        this.setState({ login: false });
    };
	
	
    render() {
        return (
            <Fragment>
                <header className="header header-v2 py-3 position-relative bg-white m-0">
                    <div className="container-fluid">
                        <div className="d-flex align-items-center justify-content-between">
                            <div className="flex-body item-left"> 
                                <a className="brand d-block m-0" href="/"><img width="142" height="30" src="/images/logo.png" alt="logo"/></a>
                            </div>
                            <div className="sub-container"></div>
                            <div className="flex-body item-right right links">
                                <a
                                    href="javascript:void(0);"
									className="border"
                                    onClick={ this.toggleLogin }
                                >
                                   <i className="fa fa-user mr-2"></i> Member Login
                                </a>
							</div>
                        </div>
                    </div>
                </header>
				{this.state.login === true ? <Login toggleResetPassword={this.toggleResetPassword} toggleLogin={this.toggleLogin}></Login> : ""}
				{this.state.resetPassword === true ? <Reset toggleResetPassword={this.toggleResetPassword}></Reset> : ""}
            </Fragment>
        );
    }
}
Header.contextType = AppContext;

export default withRouter(({ location, ...props }) => {
    return <Header {...props}   />;
 });


// WEBPACK FOOTER //
// ./src/components/auth/Header.js